import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

// Apre/evidenzia l'elemento indicato da ?open=<id> (link da ricerca globale e notifiche).
export function useOpenParam(items, onOpen) {
  const [sp] = useSearchParams();
  const id = sp.get("open");
  const done = useRef(null);
  useEffect(() => {
    if (!id || done.current === id || !items?.length) return;
    const it = items.find((x) => x.id === id);
    if (!it) return;
    done.current = id;
    if (onOpen) onOpen(it);
    setTimeout(() => { document.getElementById(`open-${id}`)?.scrollIntoView({ behavior: "smooth", block: "center" }); }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, items]);
  return id;
}
